import PropTypes from 'prop-types';
import { userSharedProps } from '@common/propTypes';

export const userPropType = PropTypes.shape({
  ...userSharedProps,
  companyId: PropTypes.string,
  roleIds: PropTypes.arrayOf(PropTypes.string).isRequired,
});

export const accountUserPropType = PropTypes.shape({
  ...userSharedProps,
  defaultCompanyId: PropTypes.string,
  defaultRoleId: PropTypes.string,
});

export const licenseDropdownOptionPropType = PropTypes.shape({
  available: PropTypes.number,
  category: PropTypes.string,
  externalKey: PropTypes.string,
  name: PropTypes.string,
  plc: PropTypes.string,
  ranking: PropTypes.number,
  type: PropTypes.string,
});

export const licenseDropdownPropType = PropTypes.shape({
  category: PropTypes.string,
  externalLicense: PropTypes.bool,
  inputType: PropTypes.string,
  options: PropTypes.arrayOf(licenseDropdownOptionPropType),
  showOffering: PropTypes.bool,
  title: PropTypes.string,
});
